import { AfterViewInit, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthContext } from '../../auth/services/auth.context';
import { ManageUserRequestsComponent } from '../user-management/manage-user-requests/manage-user-requests.component';
import { LookupItem } from '../../core/services/lookup.service';
import { MatCardModule } from '@angular/material/card';
import { UserDashboardComponent } from '../dashboard/user-dashboard/user-dashboard.component';
import { MetricsDashboardComponent } from '../dashboard/metrics-dashboard/metrics-dashboard.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    ManageUserRequestsComponent,
    UserDashboardComponent,
    MatCardModule,
    MetricsDashboardComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, AfterViewInit {

  private snackBar = inject(MatSnackBar);

  userRole: string = '';
  greeting = "Good Morning";
  loggedInUserName: string = '';
  hour = new Date().getHours();

  complaintLineStatusType!: LookupItem[];
  quotes: string[] = [
    "The Earth is not an inheritance from our ancestors; it is a loan to our children.",
    "We do not inherit the Earth from our ancestors; we borrow it from our children.",
    "The Earth is like a library, and we are like children in it. We don't own it, we just borrow it.",
    "Nature is not a place to visit, it's home.",
    "The greatest threat to our planet is the belief that we have time to change.",
    "The Earth is a finite planet. Its resources are limited. We must learn to live within our means.",
    "There is no such thing as a free lunch. We must pay the price for our actions, including our actions on the environment.",
    "We cannot continue to consume resources at an unsustainable rate. We must learn to live in harmony with nature.",
    "The only way to save our planet is to change ourselves.",
    "We need to create a world where the only waste is waste.",
    "Pollution is a tax on future generations.",
    "Climate change is the greatest threat to our planet.",
    "We are the first generation to know we are destroying the planet and the last generation that can do something about it.",
    "We are all interconnected. What affects one of us affects all of us.",
    "The Earth is crying out for help. We must listen.",
    "The sun is the ultimate source of energy. We must learn to harness its power.",
    "The future is renewable. We must invest in clean energy.",
    "We must move away from fossil fuels and towards a sustainable energy future.",
    "The best way to save the planet is to invest in renewable energy.",
    "We must create a world where the sun shines on everyone.",
    "Water is life. We must protect it.",
    "Every drop counts.",
    "We cannot afford to waste water. It is a precious resource.",
    "The future is water. We must learn to conserve it.",
    "Water is the elixir of life. We must protect it at all costs.",
    "Turn off the lights when you leave the room.",
    "Conserve energy. Save the planet.",
    "Every kilowatt-hour counts.",
    "Energy conservation is a small price to pay for a healthy planet.",
    "We must learn to live more sustainably and consume less energy.",
    "Reduce, reuse, recycle.",
    "Waste not, want not.",
    "Every piece of trash has a story. Let's change the story.",
    "Recycling is not a waste of time, it's an investment in our future.",
    "We must create a world where there is no waste.",
    "Biodiversity is the insurance policy for our planet.",
    "We must protect our wildlife. They are our brothers and sisters.",
    "Every species counts. We must protect them all.",
    "We are destroying our planet one species at a time.",
    "The loss of biodiversity is a tragedy for our planet.",
    "Forests are the lungs of our planet.",
    "Plant a tree. Save the planet.",
    "Deforestation is a crime against humanity.",
    "We must protect our forests. They are our heritage.",
    "Forests are the future of our planet. We must protect them.",
    "The ocean is our lifeblood. We must protect it.",
    "The ocean is a treasure. We must protect it.",
    "Ocean pollution is a global crisis. We must act now.",
    "The ocean is our future. We must protect it.",
    "We are all connected to the ocean. We must protect it.",
    "The Earth is not an inheritance from our ancestors; it is a loan to our children.",
    "We do not inherit the Earth from our ancestors; we borrow it from our children.",
    "The Earth is like a library, and we are like children in it. We don't own it, we just borrow it.",
    "Nature is not a place to visit, it's home.",
    "The greatest threat to our planet is the belief that we have time to change.",
    "The Earth is a finite planet. Its resources are limited. We must learn to live within our means.",
    "There is no such thing as a free lunch. We must pay the price for our actions, including our actions on the environment.",
    "We cannot continue to consume resources at an unsustainable rate. We must learn to live in harmony with nature.",
    "The only way to save our planet is to change ourselves.",
    "We need to create a world where the only waste is waste.",
    "Pollution is a tax on future generations.",
    "Climate change is the greatest threat to our planet.",
    "We are the first generation to know we are destroying the planet and the last generation that can do something about it.",
    "We are all interconnected. What affects one of us affects all of us.",
    "The Earth is crying out for help. We must listen.",
    "The sun is the ultimate source of energy. We must learn to harness its power.",
    "The future is renewable. We must invest in clean energy.",
    "We must move away from fossil fuels and towards a sustainable energy future.",
    "The best way to save the planet is to invest in renewable energy.",
    "We must create a world where the sun shines on everyone.",
    "Water is life. We must protect it.",
    "Every drop counts.",
    "We cannot afford to waste water. It is a precious resource.",
    "The future is water. We must learn to conserve it.",
    "Water is the elixir of life. We must protect it at all costs.",
    "Turn off the lights when you leave the room.",
    "Conserve energy. Save the planet.",
    "Every kilowatt-hour counts.",
    "Energy conservation is a small price to pay for a healthy planet.",
    "We must learn to live more sustainably and consume less energy.",
    "Reduce, reuse, recycle.",
    "Waste not, want not.",
    "Every piece of trash has a story. Let's change the story.",
    "Recycling is not a waste of time, it's an investment in our future.",
    "We must create a world where there is no waste.",
    "Biodiversity is the insurance policy for our planet.",
    "We must protect our wildlife. They are our brothers and sisters.",
    "Every species counts. We must protect them all.",
    "We are destroying our planet one species at a time.",
    "The loss of biodiversity is a tragedy for our planet.",
    "Forests are the lungs of our planet.",
    "Plant a tree. Save the planet.",
    "Deforestation is a crime against humanity.",
    "We must protect our forests. They are our heritage.",
    "Forests are the future of our planet. We must protect them.",
    "The ocean is our lifeblood. We must protect it.",
    "The ocean is a treasure. We must protect it.",
    "Ocean pollution is a global crisis. We must act now.",
    "The ocean is our future. We must protect it.",
    "We are all connected to the ocean. We must protect it.",
    "The Earth is not an inheritance from our ancestors; it is a loan to our children.",
    "We do not inherit the Earth from our ancestors; we borrow it from our children.",
    "The Earth is like a library, and we are like children in it. We don't own it, we just borrow it.",
    "Nature is not a place to visit, it's home.",
    "The greatest threat to our planet is the belief that we have time to change.",
    "The Earth is a finite planet. Its resources are limited. We must learn to live within our means.",
    "There is no such thing as a free lunch. We must pay the price for our actions, including our actions on the environment.",
    "We cannot continue to consume resources at an unsustainable rate. We must learn to live in harmony with nature.",
    "The only way to save our planet is to change ourselves.",
    "We need to create a world where the only waste is waste.",
    "Pollution is a tax on future generations.",
    "Climate change is the greatest threat to our planet.",
    "We are the first generation to know we are destroying the planet and the last generation that can do something about it.",
    "We are all interconnected. What affects one of us affects all of us.",
    "The Earth is crying out for help. We must listen.",
    "The sun is the ultimate source of energy. We must learn to harness its power.",
    "The future is renewable. We must invest in clean energy.",
    "We must move away from fossil fuels and towards a sustainable energy future.",
    "The best way to save the planet is to invest in renewable energy.",
    "We must create a world where the sun shines on everyone.",
    "Water is life. We must protect it.",
    "Every drop counts.",
    "We cannot afford to waste water. It is a precious resource.",
    "The future is water. We must learn to conserve it.",
    "Water is the elixir of life. We must protect it at all costs."];
  quoteText: string = '';

  constructor(
    private authContext: AuthContext,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.authContext.userInfo$.subscribe(user => {
      if (user) {
        this.userRole = user.userType;
        const lastName = user.lastName ? ' ' + user.lastName : '';
        if (this.userRole === 'ROLE_USER') {
          this.loggedInUserName = 'Resident';
        } else {
          this.loggedInUserName = user.firstName + lastName;
        }
        this.greeting = "Good " + (this.hour < 12 ? "Morning \u26C5" : this.hour < 15 ? "Afternoon 🌞" : "Evening 🌙");
        
        this.authContext.lookUpValue$.subscribe(lookups => {
          if (lookups) {
            this.complaintLineStatusType = lookups['COMPLAINT_LINE_STATUS_TYPE'];
            this.cdr.detectChanges();
          }
        });
      }
    });

    this.quoteText = this.getRandomQuote();

  }

  ngAfterViewInit() {
    this.cdr.detectChanges();  // Force a re-render after the view initializes
  }

  openSnackBar(message: string, action?: string) {
    this.snackBar.open(message, action, { duration: 3 * 1000 }); // 3 seconds
  }

  getRandomQuote() {
    const randomIndex = Math.floor(Math.random() * this.quotes.length);
    return this.quotes[randomIndex];
  }

}
